
import { Component, Ref, Vue } from 'vue-property-decorator'
import UnorderedList from '@/components/molecules/UnorderedList.vue'
import ListItem from '@/components/molecules/ListItem.vue'
import ModalInputText from '@/components/templates/ModalInputText.vue'
import { StudyModel } from '@/models/StudyModel'

/**
 * 解答入力モーダル(テキスト入力)
 */
@Component({
  components: {
    UnorderedList,
    ListItem,
    ModalInputText,
  },
})
export default class ModalCorrectInputText extends Vue {
  /** モーダル要素 */
  @Ref()
  modalInputText!: ModalInputText

  /** 入力完了後に実行する処理 */
  private afterFunction?: StudyModel.AfterInputFunction

  /**
   * モーダルの表示処理
   *
   * @param question 設問情報
   * @param index 入力欄のインデックス
   * @param afterFunction 入力完了後の処理
   */
  public showModal(question: StudyModel.Question, index: number, afterFunction: StudyModel.AfterInputFunction): void {
    // ローディング開始
    this.$loading.start()

    // 入力後処理の保存
    this.afterFunction = afterFunction

    // モーダル表示
    this.modalInputText.show(question.managementLabel, question.inputValues[index])

    // ローディング終了
    this.$loading.complete()
  }

  /**
   * 入力値確定時の処理
   *
   * @param inputValue 入力値
   */
  private submitInput(inputValue: string): void {
    // undefinedブロックしているが、実際には必ず実行される
    if (!this.afterFunction) {
      return
    }
    this.afterFunction(inputValue)
  }
}
